export const SITE_NAME = 'FERAL-AUD.IO';
export const CONTACT_EMAIL = 'hey-you@feral-aud.io';
export const COPYRIGHT_YEAR = new Date().getFullYear();
export const COPYRIGHT_TEXT = `© ${COPYRIGHT_YEAR} FERAL-AUD.IO. All rights reserved.`;

export const SOCIAL_LINKS = {
  DISCORD: 'https://discord.gg/NZkdjYwg9f',
  APP_STORE: 'https://apps.apple.com/us/developer/steffen-m%C3%B8lgaard-larsen/id1860980002',
};

export const ARIA_LABELS = {
  MAIN_NAV: 'Main navigation',
  DISCORD_BUTTON: 'Join our Discord community',
  APP_STORE_BUTTON: 'Download on the App Store',
  EMAIL_LINK: 'Contact us via email',
  LOGO: 'FERAL-AUD.IO home',
};
